import React, { useState } from "react"
import styled from "styled-components"
import {
  hyphenDelimitedLowerCase,
  getContentTemplateData,
  generateFAQs,
  getLateNiteMerchants,
} from "../utils/functions"

import Layout from "../components/layout"
import CarouselWrapper from "../components/PhoenixWrappers/carousel"
import InternalLinkingBlock from "../components/internalLinkingBlock"
import InternalLinkingMerchant from "../components/internalLinkingMerchant"
import Link from "@airasia/phoenix-components/components/Link"
import CategoryTileFilter from "../components/PhoenixWrappers/CategoryTileFilter"
import FlexCards from "../components/PhoenixWrappers/FlexCards"
import Autocomplete from "@airasia/phoenix-components/components/Autocomplete"
import ExpandableTextContainer from "@airasia/phoenix-widgets/widgets/ExpandableTextContainer"
import FAQ from "@airasia/phoenix-widgets/widgets/FAQ"
import Title from "@airasia/phoenix-components/components/Title"
import Text from "@airasia/phoenix-components/components/Text"
import { Translate } from "../utils/translation"
import { GTM_PROJECT_CATEGORY } from "../utils/constants"
import { Cities } from "../utils/homepageCarousel"
import { getGtmUserType, fireGtmEvent } from "../utils/functions"

const ContentWrapper = styled.div`
  margin-top: 2%;

  @media only screen and (max-width: 768px) {
    #pageTitle {
      font-size: 1.5rem;
    }

    #pageDescription {
      font-size: 0.9rem;
    }

    #autocomplete {
      font-size: 0.8rem;
    }
  }

  #airasia-product-tiles {
    position: initial;
  }
`

const MobileContainer = styled.div`
  @media only screen and (min-width: 768px) {
    display: none;
  }
`

const DesktopContainer = styled.div`
  @media only screen and (max-width: 768px) {
    display: none;
  }
`

const AutoCompleteWrapper = styled.div`
  margin-top: 2%;
  margin-bottom: 2%;
  width: 100%;
  @media only screen and (min-width: 768px) {
    width: 50%;
  }
`

const CityPage = props => {
  // console.log('Page Context', props.pageContext)
  const data = props.pageContext.mergedData || {}
  const type = "city"
  var location = props.pageContext.location
  const countryUrl = props.pageContext.countryUrl
  const URL = props.pageContext.url
  const CTA = props.pageContext.cta
  var expandCtaText = "Read More"
  var compressCtaText = "Read Less"
  const countryName = props.pageContext.countryName
  const countryCode = props.pageContext.countryCode
  var isIntheList = false
  var mobileBannerImage = countryUrl ==="/th/th/"?"https://static.stgairasia.com/seo/static-assets/SEOFood/banner/th-th/Food-Delivery-Generic_mobile_new.jpg":"https://static.stgairasia.com/seo/static-assets/SEOFood/banner/Food-Delivery-Generic_mobile_new2.jpg"
  var desktopBannerImage = countryUrl ==="/th/th/"?"https://static.stgairasia.com/seo/static-assets/SEOFood/banner/th-th/Food-Delivery-Generic_desktop_new.jpg":"https://static.stgairasia.com/seo/static-assets/SEOFood/banner/Food-Delivery-Generic_desktop_new3.png"
  // "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/desktop_" +
  //               hyphenDelimitedLowerCase(location) +
  //               ".jpg"
  //             : "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/Food-Delivery-Generic_desktop_new.jpg",

  // tech debt: dirty fix
  if (
    Cities[countryCode] &&
    Cities[countryCode].filter(fil => fil === location).length
  ) {
    isIntheList = true
    desktopBannerImage = "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/desktop_" +
    hyphenDelimitedLowerCase(location) +".jpg"
    mobileBannerImage = "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/mobile_" +
    hyphenDelimitedLowerCase(location) +".jpg"
  }
  var indonesiaCityName = countryUrl==="/id/id/"?Translate.indoCityName[URL]:location
  var thailandCityName = countryUrl==="/th/th/"?Translate.thaiCityName[URL]:location
  let translationCityName
  location = location
    ? location
        .toLowerCase()
        .split(" ")
        .map(s => s.charAt(0).toUpperCase() + s.substring(1))
        .join(" ")
    : location

  var carouselData = data ? data.categories : []
  carouselData = carouselData.concat(data.tags)
  // console.log(carouselData)

  var faqTitle = "FAQs"
  // Categories for product tile component
  const foodCategories = props.pageContext.mergedData.categories.map(
    category => {
      return category.category
    }
  )

  // const defaultCategory = foodCategories.length > 0 ? foodCategories[foodCategories.length-1] : ""
  const defaultCategory = foodCategories.length > 0 ? "All" : ""


  // Label value pair for autocomplete tag search
  var autoCompleteItems = props.pageContext.mergedData.tags.map(tag => {
    return {
      label: tag.tag,
      value: tag.tag,
    }
  })

  // food type ENUM for filterCarouselData
  // the values must match that of the the mergedData in the page context
  const foodTypes = {
    category: "category",
    tag: "tag",
  }

  const filterCarouselData = (filterKey, type) => {
    return carouselData.filter(fil => fil[type] === filterKey)[0]
      ? carouselData.filter(fil => fil[type] === filterKey)[0].stores
      : []
  }

  const [selectedFoodCategory, setSelectedFoodCategory] = useState(
    defaultCategory
  )
  const [selectedFoodMerchants, setSelectedFoodMerchants] = useState(
    filterCarouselData(defaultCategory, foodTypes.category)
  )

  let defaultAutoCompleteLabel = "Wraps, Sushi or Bubble Tea? Search now!"
  let cityInternalLinkingTitle= countryUrl ==="/th/th/"?`ลองแอร์เอเชียฟู๊ดในพื้นที่อื่นๆ`:`Try airasia food in other locations`
  let otherCitiesListLabel = countryUrl === "/th/th/" ? "อาหารเดลิเวอรี่ใน" :"Food Delivery in "
  let otherCitiesListURL =""
  if(countryUrl ==="/id/id/"){
    cityInternalLinkingTitle ="Coba airasia food di lokasi lainnya"
    otherCitiesListLabel = "Pesan Antar Makanan di "
    otherCitiesListURL = "/id/id"
  }
  if(countryUrl ==="/th/th/"){
    otherCitiesListURL = "/th/th"
  }
  const lateNiteMerchants = getLateNiteMerchants(carouselData)
 //hardcode nearbyLocation based on Thai Team Requested
  if(URL=="nonthaburi"){
    props.pageContext.nearbyLocation = ["Mueang Nonthaburi","Bang Kruai","Bang Yai","Bang Bua Thong","Sai Noi","Pak Kret"]
  }
  if(URL=="samutprakan")
  {
    props.pageContext.nearbyLocation = ["Mueang Samut Prakan","Bang Bo","Bang Phli", "Phra Pradaeng","Phra Samut Chedi","Bang Sao Thong"]
  }
  let otherCitiesList = props.pageContext.nearbyLocation.map(city => {
    // var thaiName = Translate.thaiCityName[hyphenDelimitedLowerCase(city)]
    // var indoName = Translate.indoCityName[hyphenDelimitedLowerCase(city)]
    const otherCitiestranslationName = countryUrl ==="/th/th/"? Translate.thaiCityName[hyphenDelimitedLowerCase(city)]:Translate.indoCityName[hyphenDelimitedLowerCase(city)]
    return {
      href: "/"+hyphenDelimitedLowerCase(city)+otherCitiesListURL,
      label: otherCitiestranslationName?otherCitiesListLabel+otherCitiestranslationName:otherCitiesListLabel+city,
    }
  })
  otherCitiesList = otherCitiesList.filter((v,i,a)=>a.findIndex(t=>(t.href === v.href && t.label===v.label))===i)

  const cityInternalLinking = [
    {description: "", link_objects: [...otherCitiesList], 
    title: cityInternalLinkingTitle},
    ]
  // console.log("cityInternalLinking",cityInternalLinking)

  let lateNiteMerchantsData = lateNiteMerchants.map(store => {
    return {
      href: store.store.store_url,
      label: store.store.name,
    }
  })  
  lateNiteMerchantsData = lateNiteMerchantsData.filter((v,i,a)=>a.findIndex(t=>(t.href === v.href && t.label===v.label))===i)
  let internalLinkingTitle = countryUrl ==="/th/th/"?"หากยังคิดไม่ออกว่าจะทานอะไร ลองคลิกร้านอาหารใกล้คุณแล้วเลือกอาหารที่คุณชื่นชอบได้เลย":`Not sure what to order? Check out these merchants nearby`
  
  // console.log("countryUrl",countryUrl)
  let pageTitle = `Food Delivery in ${location}`
  let pageDescription = `Tasty food for everyone! Search for the cravings of your choice or
  quickly select a cuisine to order food from the best restaurants in ${location}`

  if (countryUrl === "/th/th/") {
    pageTitle = `สั่งอาหารออนไลน์ใน${thailandCityName?thailandCityName:location}`
    pageDescription = `อาหารแสนอร่อยพร้อมเสิร์ฟสำหรับทุกคน! เลือกจานโปรดของคุณ หรือเลือกจากร้านอาหารที่ดีที่สุดใน${thailandCityName?thailandCityName:location}`
    defaultAutoCompleteLabel = "ข้าว ก๋วยเตี๋ยว หรือว่าชาไข่มุกดีนะ? ค้นหาเลย!"
    faqTitle = "คำถามที่พบบ่อย"
    expandCtaText = "อ่านเพิ่มเติม"
    compressCtaText = "ซ่อน"
    translationCityName = thailandCityName
  }
  // console.log("indonesiaCityName",indonesiaCityName)
  // console.log("categories: ",props.pageContext.mergedData.categories)

  if(countryUrl==="/id/id/"){
    pageTitle =`Pesan Antar Makanan di ${indonesiaCityName?indonesiaCityName:location}`
    pageDescription = `Makanan yang lezat untuk semua orang! Cari dan temukan makanan pilihan Anda atau pilih makanan dengan cepat dari restoran terbaik di ${indonesiaCityName?indonesiaCityName:location}`
    defaultAutoCompleteLabel = "Wrap, Mie, atau Bubble Tea? Cari sekarang!"
    faqTitle = "Pertanyaan dan Jawaban"
    internalLinkingTitle = "Tidak yakin dengan apa yang ingin Anda pesan? Cek merchant terdekat ini"
    expandCtaText = "Selanjutnya"
    compressCtaText = "Tutup"
    translationCityName = indonesiaCityName

  }
  const contentData = getContentTemplateData(translationCityName?translationCityName:location,countryUrl)
  const FAQ_DATA = generateFAQs(translationCityName?translationCityName:location, carouselData, countryUrl)

  const lateNiteMerchantInternalLinking = [
    {description: "", link_objects: [...lateNiteMerchantsData.slice(0,8)], 
    title: lateNiteMerchantsData.length?internalLinkingTitle:""},
    ]
  const [autoCompleteLabel, setAutoCompleteLabel] = useState(
    defaultAutoCompleteLabel
  )
  const [autoCompleteValue, setAutoCompleteValue] = useState()

  const handleTileClick = productId => {
    setSelectedFoodCategory(productId)
    setSelectedFoodMerchants(filterCarouselData(productId, foodTypes.category))
    setAutoCompleteValue()
    setAutoCompleteLabel(defaultAutoCompleteLabel)
  }

  const LinkCard = ({title="", href=""}) => {
    return (
        <div style={{ width: '100%', height: 20, marginTop: '2%' }}>
          <Text>{countryUrl==="/th/th/"?"อยากไปทานที่ร้าน? ":"Plan for dine in? "}&nbsp;</Text>
            <Link
                accessible
                color="secondary"
                hoverUnderlined
                href={href}
                size="normal"
                stopPropagation
                target="tab"
                theme="AIRASIA_CLASSIC"
                type="normal">
                    {title}
                </Link>
        </div>
    )
  }
   
  return location ? (
    <Layout
      pageData={{
        heroBanner: [
          {
            altText: `${location} food delivery banner`,
            bannerID: `${location.replace(" ", "")}Page`,
            // buttonText: "Read more",
            buttonUrl: "",
            desktopImage: (isIntheList && countryUrl ==="/th/th/"||countryUrl ==="/id/id/")
              ? "https://static.stgairasia.com/seo/static-assets/SEOFood/banner"+countryUrl.substring(0, 3)+ '-' + countryUrl.substring(3+1)+"desktop_" +
                hyphenDelimitedLowerCase(location) +
                ".jpg"
              : desktopBannerImage,
            headline: "",
            mobileImage: (isIntheList && countryUrl ==="/th/th/")
              ? "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/th-th/mobile_" +
                hyphenDelimitedLowerCase(location) +
                ".jpg"
              : mobileBannerImage,
            redirectUrl: "https://www.airasia.com/food",
            showButton: false,
            subheadline: "",
            tabletImage: (isIntheList && countryUrl ==="/th/th/")
              ? "https://static.stgairasia.com/seo/static-assets/SEOFood/banner/th-th/mobile_" +
                hyphenDelimitedLowerCase(location) +
                ".jpg"
              : mobileBannerImage,
          },
        ],
      }}
      url={URL}
      location={translationCityName?translationCityName:location}
      type={type}
      countryUrl={countryUrl}
      countryName={countryName}
      countryCode={countryCode}
    >
      <ContentWrapper>
        <Title customProperties={{ id: "pageTitle" }} type="h1">
          {pageTitle}
        </Title>
        <Text customProperties={{ id: "pageDescription" }} type="medium">
          {pageDescription}
        </Text>
        {URL=="bangkok"?
          <LinkCard href={countryUrl==="/th/th/"?"https://www.airasia.com/aa/food/th/th/restaurant-queuing-service.html":"https://www.airasia.com/aa/food/en/th/restaurant-queuing-service.html"} title={countryUrl==="/th/th/"?" จองคิวร้านอาหารดังทั่วไทยกับแอร์เอเชียได้แล้ววันนี้":" Book your restaurant in Bangkok here with airasia"} />:<></>
        }
        
        <AutoCompleteWrapper>
          {/* <Autocomplete
            customProperties={{ id: "autocomplete" }}
            items={autoCompleteItems}
            label={autoCompleteLabel}
            value={autoCompleteValue}
            onSelect={item => {
              setSelectedFoodMerchants(
                filterCarouselData(item.value, foodTypes.tag)
              )
              setAutoCompleteValue(item.value)

              const obj = {
                event: "trackEventNoEcommerce",
                "eventDetails.category": `${GTM_PROJECT_CATEGORY} | Autocomplete`,
                "eventDetails.action": `search`,
                "eventDetails.label": `${GTM_PROJECT_CATEGORY} | ${getGtmUserType()} | ${
                  item.value
                }`,
              }

              fireGtmEvent(obj)
            }}
            onClick={() => {
              setAutoCompleteLabel(
                countryUrl === "/th/th/" ? "กำลังหิวอยู่..." : "I am craving..."
              )

              const obj = {
                event: "trackEventNoEcommerce",
                "eventDetails.category": `${GTM_PROJECT_CATEGORY} | Autocomplete`,
                "eventDetails.action": `click`,
                "eventDetails.label": `${GTM_PROJECT_CATEGORY} | ${getGtmUserType()}`,
              }

              fireGtmEvent(obj)
            }}
          /> */}
        </AutoCompleteWrapper>
        <DesktopContainer>
          <CategoryTileFilter
            categoryIds={foodCategories}
            highlightTileByDefaultId={defaultCategory}
            onTileClick={(_, productId) => handleTileClick(productId)}
            countryUrl={countryUrl}
          />
          {selectedFoodMerchants && (
            <ContentWrapper>
              <FlexCards
                title={selectedFoodCategory}
                cardData={selectedFoodMerchants}
                cta={CTA}
              />
            </ContentWrapper>
          )}
        </DesktopContainer>
        <MobileContainer>
          <CategoryTileFilter
            device="mobile"
            categoryIds={foodCategories}
            highlightTileByDefaultId={defaultCategory}
            onTileClick={(_, productId) => handleTileClick(productId)}
            countryUrl={countryUrl}
          />
          {selectedFoodMerchants && CTA && (
            <ContentWrapper>
              <CarouselWrapper
                title={selectedFoodCategory}
                data={selectedFoodMerchants}
                countryUrl={countryUrl}
                lazyLoadImage={true}
                enableProgressiveImageLoading={false}
                cta={CTA}
              />
            </ContentWrapper>
          )}
        </MobileContainer>
      </ContentWrapper>
      {lateNiteMerchantsData &&
        lateNiteMerchantInternalLinking.map(linking => {
          return (
            <ContentWrapper>
              <InternalLinkingMerchant
                linkObjects={linking.link_objects}
                blockTitle={linking.title}
                blockDescription={linking.description}
              />
            </ContentWrapper>
          )
        })}
      {cityInternalLinking &&
        cityInternalLinking.map(linking => {
          return (
            <ContentWrapper>
              <InternalLinkingBlock
                linkObjects={linking.link_objects}
                blockTitle={linking.title}
                blockDescription={linking.description}
              />
            </ContentWrapper>
          )
        })}
      <ContentWrapper>
        <ExpandableTextContainer
          data={contentData}
          dataSliceLimit={1}
          expandCtaText={expandCtaText ? expandCtaText : "Read more"}
          compressCtaText={compressCtaText ? compressCtaText :"Read Less"}
          ctaColor="secondary"
          ctaHoverColor="neutral"
          ctaHoverUnderlined
          ctaSize="normal"
          ctaUnderlined
          dataProperties={{
            compressCtaText: compressCtaText ? compressCtaText :"Read less",
            ctaColor: "primary",
            ctaHoverColor: "neutral",
            ctaHoverUnderlined: true,
            ctaSize: "small",
            ctaUnderlined: false,
            expandCtaText: expandCtaText ? expandCtaText : "Read more",
            sliceLimit: 350,
            textColor: "neutral",
            textType: "sub",
            titleColor: "neutral",
            titleMarginBottom: "normal",
            titleType: "h3",
          }}
        />
      </ContentWrapper>
      <ContentWrapper>
        <FAQ
          data={FAQ_DATA}
          title={faqTitle}
          titleMarginBottom="normal"
          titleType="h2"
        />
      </ContentWrapper>
    </Layout>
  ) : (
    <></>
  )
}
export default CityPage
